// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__H0yk1","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3UFGA"};